import { CalendarCheck, ExternalLink, Unlock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Reveal, SectionHeading } from "./Reveal";
import { MARKET } from "../data/siteData";

export const Market = () => {
  const { t } = useLanguage();

  return (
    <section id="mercado" className="scroll-mt-20 border-t border-ink-700/60 bg-ink-900/40 py-20 sm:py-28" data-testid="market-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <SectionHeading eyebrow={t.market.eyebrow} title={t.market.title} testId="market-heading" />
        </Reveal>

        <div className="grid gap-4 lg:grid-cols-2">
          <Reveal className="h-full">
            <div
              data-testid="market-value-card"
              className="flex h-full flex-col border border-ink-700/60 bg-ink-800 p-8 sm:p-10"
            >
              <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-400">
                {t.market.valueLabel}
              </p>
              <p className="mt-4 font-display text-6xl font-extrabold tracking-tight text-kit sm:text-7xl" data-testid="market-value-amount">
                {MARKET.value}
              </p>
              <p className="mt-6 max-w-md text-xs leading-relaxed text-zinc-400" data-testid="market-disclaimer">
                {t.market.disclaimer}
              </p>
              <a
                data-testid="transfermarkt-external-link"
                href={MARKET.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex w-fit items-center gap-2 border border-ink-600 px-4 py-2 text-xs font-bold uppercase tracking-[0.12em] text-white transition-colors duration-200 hover:border-kit hover:text-kit"
              >
                {t.market.sourceLink} <ExternalLink size={13} />
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="h-full">
            <div
              data-testid="contract-status-card"
              className="flex h-full flex-col justify-center gap-5 border border-ink-700/60 bg-ink-900 p-8 sm:p-10"
            >
              <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-400">
                {t.market.contractTitle}
              </p>
              <div className="flex items-start gap-4">
                <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center border border-kit/40 bg-kit/10 text-kit">
                  <CalendarCheck size={18} />
                </span>
                <div>
                  <p className="font-display text-2xl font-bold uppercase text-white" data-testid="market-contract-until">
                    {t.market.contract}
                  </p>
                  <p className="mt-1 text-sm text-zinc-400">Deportes Antofagasta</p>
                </div>
              </div>
              <div className="flex items-start gap-4 border-t border-ink-700/60 pt-5">
                <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center border border-ink-600 text-zinc-300">
                  <Unlock size={18} />
                </span>
                <div>
                  <p className="font-display text-2xl font-bold uppercase text-white" data-testid="market-free-agent">
                    {t.market.freeAgent}
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
